<div class="security-equivalents-container" id="security-equivalents-component">
  @if (!isCashType) {
  <!--    <div class="security-equivalents-container-row">-->
  <!--        <div class="security-equivalents-container-element">-->
  <!--            <div class="security-equivalents-element-label security-equivalents-add-header">{{ securityCount == 1 ? securityCount + " equivalent security; " + heldCount + " alt if held " : securityCount + " equivalent securities; " + heldCount + " alt if held "}} </div>-->
<!--        </div>-->
<!--    </div>-->
<div class="security-equivalents-container-row">
  <div class="security-equivalents-container-element">
    <div class="security-equivalents-element-label security-equivalents-add-header">{{ getEquivalentsText()}}
      <span id="addSecurityRestrictionsToolTipIcon"
        class="infoIcon" calltoaction
      [calltoactionTemplate]="securityEquivalentsToolTipTemplateRef"></span>
    </div>

    <ng-template #securityEquivalentsToolTipTemplateRef>
      <div>
        <p>Select the securities you want to have considered as "equivalent" to a security when calculating
          a portfolio's allocations. Equivalent securities will not be purchased in place of each other,
        but can be sold.</p>

        <p>You can also select any securities you'd like iRebal to purchase as alternates to a specific
          security held in the portfolio. <strong>Alt if Held</strong> securities are those you'd like
          iRebal to purchase
          instead of a specific security when the <strong>Alt if Held</strong> is already in the account.
          If you specify
        multiple alternates, iRebal will purchase whichever one there's more of in the account.</p>

      </div>
    </ng-template>
  </div>
</div>
<div class="security-equivalents-container-row">
  <div class="security-equivalents-container-element">
    <div class="security-equivalents-element-label">Add Security equivalents</div>
    <div class="security-equivalents-element-input">
      <irb-dropdown-search-multiple
        #equivalentSecuritiesDropdown
        [addNewItem]="addNewSecurityItem"
        (openNewItemFlow)="openNewItemSecurityFlow($event)"
        [(values)]="selectedEquivalentSecurity"
        (search)="getItemsForEquivalentSecuritiesDropdown($event)"
        (selection)="onSingleEquivalentChanged($event)"
        [enableHiddenSearchResults]="true"
        width="140">
      </irb-dropdown-search-multiple>

    </div>
    <div class="security-equivalents-element-input">
      <button [disabled]="(selectedEquivalentSecurity ? selectedEquivalentSecurity.length === 0 : true )"
        class="btn-medium-secondary btn-spacer" (click)="onAddSymbolEquivalent()">Add
        <!--                    <div *ngIf="((selectedEquivalentSecurity?.value === 0) || isAlreadyAddedSecurity())" #singleSecurityEquivalentTooltip-->
        <!--                         tooltip tooltipPosition="bottom" [tooltipTitle]="singleEquivalentToolTipErrorMessage"-->
      <!--                         tooltipClass="error"></div>-->
    </button>

    <!-- <button id="editTaxEquivalentsAltSymbolCreateNewBtn" (click)="onCreateNewSecurity()" class="btn-medium-secondary">Create New</button> -->
  </div>
  <div class="security-equivalents-element-input">
    <button class="btn-medium-secondary btn-security-master-select btn-spacer"
      (click)="showAddMultipleSecuritiesDialog()">Advanced Filter
    </button>
  </div>
</div>

<div class="security-equivalents-container-element">
  <div class="security-equivalents-element-label">Add Category equivalents</div>
  <div class="security-equivalents-element-input">
    <irb-dropdown-search-multiple
      #customCategoriesDropdown
      [addNewItem]="addNewCategoryItem"
      (openNewItemFlow)="openNewItemCategoryFlow($event)"
      [(values)]="selectedCustomCategory"
      (search)="getItemsForCustomCategoriesDropdown($event)"
      (selection)="onCategoryChanged($event)"
      [enableEmptySearchTerm]="true"
      width="140">
    </irb-dropdown-search-multiple>

  </div>
  <div class="security-equivalents-element-input">
    <button [disabled]="(selectedCustomCategory ? selectedCustomCategory.length === 0 : true)"
      class="btn-medium-secondary btn-spacer" (click)="onAddCategoryEquivalent()">Add
      <!--                    <div *ngIf="((selectedCustomCategory?.value === 0) || isAlreadyAddedCategory())" #categoryEquivalentTooltip-->
      <!--                         tooltip tooltipPosition="bottom" [tooltipTitle]="categoryEquivalentToolTipErrorMessage"-->
    <!--                         tooltipClass="error"></div>-->
  </button>

</div>
</div>
</div>
@if (!isUiTest) {
  <irb-inventory-grid
    class="edit-security-equivalents-grid-ag"
    [style.width]="'100%'"
    [gridHeight]="gridHeight"
    [showSideBar]="false"
    [gridOptions]="gridOptions"
    [frameworkComponents]='frameworkComponents'
  (gridReady)="onGridReady($event)"></irb-inventory-grid>
}

  }
  @if (isCashType) {
    <div class="security-equivalents-com">
        <div class="block">
            Select the purchased money market funds to have considered equivalent to cash when calculating a portfolio’s allocations.
        </div>

        <div class="block">
            <irb-expando-link text="How do cash equivalents work in iRebal?">
                <div class="block">
                    You may include money market funds when calculating cash targets. To set a cash floor which does not include money market funds, set a cash floor in iRebal settings.
                </div>

                <div class="block">
                    Adding a money market fund as a $CASH equivalent will remove any restrictions, equivalents, or alternatives that were configured for that money market fund.
                </div>

                <div class="block">
                    Money market funds may have a minimum buy that can impact purchase order.
                </div>
            </irb-expando-link>
        </div>

        <div class="security-equivalents-com-counters block">
            {{ securityCount }} equivalent purchased money market funds
        </div>

        <div class="security-equivalents-com-selection block">
            <div>
                <div><strong>Equivalents</strong></div>
                <div style="display: flex;">
                    <div style="padding-right: 8px;padding-top: 2px;">Purchased money market funds</div>
                    <div style="padding-right: 10px;">
                        <irb-dropdown-search-multiple
                            #equivalentSecuritiesDropdown
                            [addNewItem]="addNewSecurityItem"
                            (openNewItemFlow)="openNewItemSecurityFlow($event)"
                            [(values)]="selectedEquivalentSecurity"
                            (search)="getItemsForEquivalentSecuritiesDropdown($event)"
                            (selection)="onSingleEquivalentChanged($event)"
                            [enableHiddenSearchResults]="false"
                            [enableEmptySearchTerm]="true"
                            [placeholder]="'Select a money market fund'"
                            width="140">
                        </irb-dropdown-search-multiple>
                    </div>
                    <div>
                        <button [disabled]="(selectedEquivalentSecurity ? selectedEquivalentSecurity.length === 0 : true )"
                            class="btn-medium-secondary btn-spacer" (click)="onAddSymbolEquivalent()">Add</button>
                    </div>
                    <div class="security-equivalents-com-advanced">
                        <a  class="nav-link-text" (click)="showAddMultipleSecuritiesDialog()">Advanced Filter</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="security-equivalents-com-grid block">
            @if (!isUiTest) {
              <irb-inventory-grid
                class="edit-security-equivalents-grid-ag"
                [style.width]="'100%'"
                [gridHeight]="gridHeight"
                [showSideBar]="false"
                [gridOptions]="gridOptions"
                [frameworkComponents]='frameworkComponents'
                (gridReady)="onGridReady($event)"></irb-inventory-grid>
            }
        </div>
    </div>
  }
</div>

